export default __webpack_public_path__ + "static/vnv-c2b1757c2808994ae298c2cffb4b314f.jpg";